import React, { useEffect, useState } from 'react';
import { toast } from '../../../../ui/toast';
import { getDashboard } from '../../../../utils/api_service/dashboard';
import { formatDatePretty } from '../../../../utils/helpers/time';
import { DashboardData } from '../../../../utils/types/DashboardTypes';
import { ADMIN_PANEL_TAB } from '../Constants';
import { AssesmentTab, JobOpeningTab, UsersTab } from '../Containers';

export const useAdminDashboard = () => {
  const tabs = [
    { label: ADMIN_PANEL_TAB.JOB_OPENING },
    { label: ADMIN_PANEL_TAB.ASSESSMENT },
    { label: ADMIN_PANEL_TAB.USER },
  ];
  const [timeData, setTimeData] = useState<DashboardData>();
  const [loading, setLoading] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>('Job Opening');
  const [searchTerm, setSearchTerm] = useState<string>('');
  const today = new Date();
  const formattedDate = formatDatePretty(today);

  useEffect(() => {
    setLoading(true);
    getDashboard()
      .then((response) => {
        if (!response.ok) {
          throw new Error();
        }
        return response.json();
      })
      .then((data) => {
        setTimeData(data);
      })
      .catch(() => {
        toast.error('Error Fetching Analytics', {
          position: 'bottom-center',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderTable = () => {
    if (activeTab === ADMIN_PANEL_TAB.USER) {
      return <UsersTab searchTerm={searchTerm} />;
    } else if (activeTab === ADMIN_PANEL_TAB.ASSESSMENT) {
      return <AssesmentTab searchTerm={searchTerm} />;
    } else if (activeTab === ADMIN_PANEL_TAB.JOB_OPENING) {
      return <JobOpeningTab searchTerm={searchTerm} />;
    }
  };

  const labelOrder = [
    'Job Description',
    'Job Posting',
    'Short Listing',
    'Interview',
    'Decision Making',
    'Closed',
  ];
  const sessionLabels = ['Completed', 'Not Completed'];
  const mappedUserAssessments = timeData?.userAssessments
    ? (Object.fromEntries(
      Object.entries(timeData.userAssessments).map(([period, dataArray]) => [
        period,
        sessionLabels.map((label) => {
          // Try exact match first, then case-insensitive match
          const found = dataArray.find(
            (d) =>
              d.label === label ||
                d.label.toLowerCase() === label.toLowerCase() ||
                (label === 'Completed' && d.label.toLowerCase() === 'complete'),
          );
          return { label, value: found ? found.value : 0 };
        }),
      ]),
    ) as typeof timeData.userAssessments)
    : undefined;

  const orderedJobOpenings = timeData?.jobOpenings
    ? (Object.fromEntries(
      Object.entries(timeData.jobOpenings).map(([period, dataArray]) => [
        period,
        labelOrder.map((label) => {
          const found = dataArray.find((d) => d.label === label);
          return found ?? { label, value: 0 };
        }),
      ]),
    ) as typeof timeData.jobOpenings)
    : undefined;
  return {
    loading,
    timeData,
    activeTab,
    setActiveTab,
    searchTerm,
    setSearchTerm,
    renderTable,
    formattedDate,
    setLoading,
    tabs,
    orderedJobOpenings,
    mappedUserAssessments,
  };
};
